import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const CTASection = () => {
  return (
    <section data-testid="cta-section" className="relative py-24 md:py-32 border-t border-stone-200 overflow-hidden">
      <div className="absolute inset-0 bg-grid-sm opacity-30 pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] glow-amber pointer-events-none" />

      <div className="relative max-w-[1100px] mx-auto px-6 lg:px-10 text-center">
        <Reveal>
          <div className="text-xs uppercase tracking-[0.25em] text-[#B8860B] font-semibold mb-6">
            Let's build something that lasts.
          </div>
          <h2 className="font-display text-stone-900 text-5xl md:text-7xl lg:text-8xl font-light tracking-tighter mb-10">
            Ready to humanize<br />your <span className="italic text-[#B8860B]">technology?</span>
          </h2>
          <p className="text-lg md:text-xl text-stone-600 max-w-2xl mx-auto mb-12 leading-relaxed">
            Tell us what you're solving for. We'll bring a senior team and a point of view, not a deck.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" data-testid="cta-section-primary" className="btn-primary">
              Start a conversation <ArrowUpRight className="w-4 h-4" />
            </Link>
            <Link to="/careers" data-testid="cta-section-secondary" className="btn-secondary">
              Join the team <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTASection;
